import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/Hardware.css";
import logo from "../assets/images/teteklogo-removebg-preview.png";

const Hardware = () => {
  const navigate = useNavigate();

const startTest = (topic) => {
  navigate("/ques", { state: { topic } }); // 👈 pass topic as state
};
  return (
    <div className="hardware__container">
      <header className="hardware__header">
        <div className="hardware__company-name">
          <img src={logo} alt="Logo" style={{ height: "45px", objectFit: "contain" }} />
        </div>
        <div className="hardware__title">AI Interview Mock Test</div>
        <div className="hardware__subtitle">
          Choose your role to begin a smart, AI-powered test
        </div>
      </header>

      <h2 className="hardware__section-title">Technical Fields</h2>

      <div className="hardware__card-grid">
        <div className="hardware__card" onClick={() => startTest("cctv")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/1042/1042391.png"
            alt="CCTV Icon"
            className="hardware__card-image"
          />
          <h2 className="hardware__card-title">CCTV</h2>
          <button className="hardware__start-btn">Start Test</button>
        </div>

        <div className="hardware__card" onClick={() => startTest("networking")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/2698/2698194.png"
            alt="Networking Icon"
            className="hardware__card-image"
          />
          <h2 className="hardware__card-title">Networking</h2>
          <button className="hardware__start-btn">Start Test</button>
        </div>

        <div className="hardware__card" onClick={() => startTest("router")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/107/107837.png"
            alt="Router Icon"
            className="hardware__card-image"
          />
          <h2 className="hardware__card-title">Router</h2>
          <button className="hardware__start-btn">Start Test</button>
        </div>

        <div className="hardware__card" onClick={() => startTest("server")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/1048/1048953.png"
            alt="Server Icon"
            className="hardware__card-image"
          />
          <h2 className="hardware__card-title">Server</h2>
          <button className="hardware__start-btn">Start Test</button>
        </div>
      </div>

      <footer className="hardware__footer">© 2025 Vienstereoptic. All rights reserved.</footer>
    </div>
  );
};

export default Hardware;
